// // We need jQuery and underscore in the global namespace
// // require("expose-loader?angular!angular");
//require("expose-loader?exposes=_!underscore");
require('expose-loader?exposes=bootbox!bootbox');

// This isn't the best way to include the modules, but it seems to work...
require('../../node_modules/angular/angular');
require('../../node_modules/angular-animate/angular-animate.min');

// Vendor scripts -- should be moved to npm modules
require('../lib/bootstrap.min');
require('../lib/q-spread');
require('../lib/ui-bootstrap-tpls-1.0.0.min');
require('../lib/jquery.onoff');
require('../lib/ng-csv.min');
require('../lib/autocomplete');
require('font-awesome/css/font-awesome.min.css');
require('ui-select');
require('angular-sanitize');
require('angular-modal-service');
require('angular-ui-router');
require('angular-utils-pagination');
require('angular-loading-bar');
require('chosen-js'); // Chosenjs library

require('angular-chosen-localytics'); // Chosenjs for angular